/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockPurchaseorderHistoryCtrl
 */
angular.module('mercury.modules.stock.purchaseorder')
.controller('StockPurchaseorderHistoryCtrl', ["dialog", "$uibModal", "$scope", "StockSuppliers", "StockPurchaseOrders", "title", function(dialog, $uibModal, $scope, StockSuppliers, StockPurchaseOrders, title) {
  title.set('Purchase Order History');

  $scope.suppliers = StockSuppliers.getAll();
  $scope.supplierFilter = null;

  $scope.searchInputModel = '';

  $scope.startTime = null;
  $scope.endTime = null;

  /**
  * Function to make an ajax call to the server to get a list of orders based on the
  * current filtering parameters.
  */
  $scope.getPage = function(tableParams) {
    $scope.orders = StockPurchaseOrders.getHistory($scope.supplierFilter, $scope.startTime, $scope.endTime, $scope.searchInputModel, tableParams);
    $scope.orders.$promise.then(function(results) {
      $scope.totalCount = results.__count;
      $scope.orderHistory = results.results;
    });
  };

  /**
  * Callback for clicking the search button
  */
  $scope.commitSearch = function() {
    //Signal the pagedTable directive to update.
    $scope.$broadcast('dataTableUpdate');
  };

  $scope.commLog = function(order) {
    $scope.logs = StockPurchaseOrders.getCommLog(order.id);

    $uibModal.open({
      templateUrl: 'modules/stock/purchaseorder/commlog.tpl.html',
      scope: $scope,
      size: 'lg'
    });
  };
}]);
